import { render, staticRenderFns } from "./FeatureScreen.vue?vue&type=template&id=60ffbc47&scoped=true&"
import script from "./FeatureScreen.vue?vue&type=script&lang=ts&"
export * from "./FeatureScreen.vue?vue&type=script&lang=ts&"
import style0 from "./FeatureScreen.vue?vue&type=style&index=0&id=60ffbc47&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ffbc47",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VIcon,VTooltip})
